import * as tslib_1 from "tslib";
import { TextField } from "@awayjs/scene";
import { AS2SymbolAdapter } from "./AS2SymbolAdapter";
var AS2TextFieldAdapter = (function (_super) {
    tslib_1.__extends(AS2TextFieldAdapter, _super);
    function AS2TextFieldAdapter(adaptee, view) {
        var _this = _super.call(this, adaptee, view) || this;
        adaptee.multiline = true;
        adaptee.wordWrap = true;
        return _this;
    }
    AS2TextFieldAdapter.prototype.clone = function () {
        var clone = new AS2TextFieldAdapter(TextField.getNewTextField(), this._view);
        this.adaptee.copyTo(clone.adaptee);
        return clone;
    };
    Object.defineProperty(AS2TextFieldAdapter.prototype, "textColor", {
        get: function () {
            return this._adaptee.textColor;
        },
        set: function (value) {
            this._adaptee.textColor = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AS2TextFieldAdapter.prototype, "embedFonts", {
        get: function () {
            return this._embedFonts;
        },
        set: function (value) {
            this._embedFonts = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AS2TextFieldAdapter.prototype, "text", {
        get: function () {
            return this._adaptee.text;
        },
        set: function (value) {
            this._adaptee.text = value;
        },
        enumerable: true,
        configurable: true
    });
    return AS2TextFieldAdapter;
}(AS2SymbolAdapter));
export { AS2TextFieldAdapter };
export default AS2TextFieldAdapter;



// WEBPACK FOOTER //
// ../dist/lib/adapters/AS2TextFieldAdapter.js